import { useState } from "react";

const events = [
  { id: "GJ-2024-1847", type: "安全隐患", level: "高", title: "背街小巷围挡倒塌风险", grid: "A03-07", status: "待处理", time: "32分前", assignee: "未分配" },
  { id: "GJ-2024-1846", type: "基础设施", level: "中", title: "路灯故障无法正常亮灯", grid: "B01-12", status: "处理中", time: "1h前", assignee: "张志远" },
  { id: "GJ-2024-1845", type: "民生服务", level: "低", title: "独居老人需上门走访关怀", grid: "A01-09", status: "处理中", time: "2h前", assignee: "李晓燕" },
  { id: "GJ-2024-1844", type: "矛盾纠纷", level: "高", title: "邻里噪音矛盾升级投诉", grid: "C02-05", status: "待处理", time: "3h前", assignee: "未分配" },
  { id: "GJ-2024-1843", type: "环境卫生", level: "低", title: "绿化带垃圾清理不及时", grid: "B03-03", status: "已完成", time: "昨天", assignee: "王大明" },
];

const levelColors: Record<string, string> = {
  高: "bg-rose-100 text-rose-700 border-rose-200",
  中: "bg-amber-100 text-amber-700 border-amber-200",
  低: "bg-slate-100 text-slate-600 border-slate-200",
};
const statusColors: Record<string, string> = {
  待处理: "text-amber-600 bg-amber-50",
  处理中: "text-blue-600 bg-blue-50",
  已完成: "text-emerald-600 bg-emerald-50",
};

export default function GGMonitor() {
  const [filter, setFilter] = useState("全部");
  const filters = ["全部", "待处理", "处理中", "已完成"];
  const filtered = filter === "全部" ? events : events.filter((e) => e.status === filter);

  return (
    <section className="py-20 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="text-xs font-semibold text-indigo-600 tracking-widest uppercase mb-2 block">Real-time Monitor</span>
            <h2 className="text-3xl font-bold text-slate-800">事件闭环监控台</h2>
            <p className="text-slate-500 text-sm mt-1">从上报到归档，全程追踪每一件网格事件</p>
          </div>
          <div className="flex gap-1 bg-slate-100 rounded-xl p-1">
            {filters.map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                  filter === f ? "bg-white text-indigo-700 shadow-sm font-semibold" : "text-slate-500 hover:text-slate-700"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-3 gap-6">
          {/* Left stats */}
          <div className="flex flex-col gap-4">
            <div className="bg-gradient-to-br from-[#1a1030] to-[#1e2a50] rounded-2xl p-5 text-white">
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-pulse-line text-amber-300 text-sm"></i>
                <span className="text-white/80 text-xs font-medium">今日网格事件总览</span>
              </div>
              <div className="grid grid-cols-2 gap-3">
                {[["新增事件", "31", "text-amber-300"], ["闭环完成", "28", "text-emerald-300"], ["平均时效", "4.2h", "text-cyan-300"], ["隐患标注", "7", "text-rose-300"]].map(([l, v, c]) => (
                  <div key={l} className="bg-white/10 rounded-xl p-3">
                    <div className={`text-xl font-bold ${c}`}>{v}</div>
                    <div className="text-white/50 text-xs mt-0.5">{l}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-slate-50 rounded-2xl p-5 border border-slate-100 flex-1">
              <h4 className="text-slate-700 font-semibold text-sm mb-3">事件类型分布</h4>
              {[["安全隐患", 32, "bg-rose-400"], ["基础设施", 26, "bg-amber-400"], ["民生服务", 21, "bg-blue-400"], ["环境卫生", 13, "bg-teal-400"], ["矛盾纠纷", 8, "bg-violet-400"]].map(([type, pct, color]) => (
                <div key={type as string} className="flex items-center gap-2 mb-2.5">
                  <span className="text-slate-600 text-xs w-20 flex-shrink-0">{type}</span>
                  <div className="flex-1 bg-slate-200 rounded-full h-2">
                    <div className={`${color} rounded-full h-2`} style={{ width: `${pct}%` }}></div>
                  </div>
                  <span className="text-slate-500 text-xs w-8 text-right">{pct}%</span>
                </div>
              ))}

              <div className="mt-4 pt-4 border-t border-slate-200">
                <div className="text-xs text-slate-500 mb-2">事件闭环流程</div>
                <div className="flex items-center gap-1">
                  {["上报", "接单", "处置", "核查", "归档"].map((step, i) => (
                    <>
                      <div key={step} className="flex-1 text-center">
                        <div className="w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center mx-auto mb-1 text-xs font-bold">{i + 1}</div>
                        <div className="text-slate-500 text-xs">{step}</div>
                      </div>
                      {i < 4 && <div key={`arrow-${i}`} className="text-slate-300 text-xs flex-shrink-0">›</div>}
                    </>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Event list */}
          <div className="col-span-2 bg-slate-50 rounded-2xl border border-slate-100 overflow-hidden flex flex-col">
            <div className="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
              <span className="font-semibold text-slate-700 text-sm">事件列表</span>
              <span className="text-xs text-slate-400">{filtered.length} 条记录</span>
            </div>
            <div className="divide-y divide-slate-100 flex-1">
              {filtered.map((e) => (
                <div key={e.id} className="px-5 py-4 hover:bg-white transition-colors cursor-pointer">
                  <div className="flex items-start gap-3">
                    <span className={`text-xs border px-2 py-0.5 rounded-full flex-shrink-0 mt-0.5 ${levelColors[e.level]}`}>{e.level}级</span>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="text-slate-800 text-sm font-medium">{e.title}</span>
                        <span className="text-xs text-slate-400 bg-slate-100 px-2 py-0.5 rounded-full">{e.type}</span>
                      </div>
                      <div className="flex items-center gap-4 mt-1.5">
                        <span className="text-xs text-slate-400"><i className="ri-grid-line mr-1"></i>网格 {e.grid}</span>
                        <span className="text-xs text-slate-400"><i className="ri-user-line mr-1"></i>{e.assignee}</span>
                        <span className="text-xs text-slate-400"><i className="ri-time-line mr-1"></i>{e.time}</span>
                        <span className="text-xs text-slate-400">{e.id}</span>
                      </div>
                    </div>
                    <span className={`text-xs font-medium flex-shrink-0 px-2.5 py-1 rounded-full ${statusColors[e.status]}`}>{e.status}</span>
                  </div>
                </div>
              ))}
            </div>
            <div className="px-5 py-3 border-t border-slate-200 bg-white flex items-center justify-between">
              <span className="text-xs text-slate-400">数据实时更新 · 每30秒刷新</span>
              <button className="text-xs text-indigo-600 hover:text-indigo-700 font-medium cursor-pointer whitespace-nowrap flex items-center gap-1">
                <i className="ri-external-link-line"></i>查看全部事件
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
